<template>
	<div>
		<div class="of-media-wrap" v-bind:class="{
			'no-nav': totalAmt <= 1, 
			'has-sizer' : sizer !== null,
			'hor': totalAmt <= 1 && mediadata[0].orient === 'hor',
			'vidonly': totalAmt <= 1 && mediadata[0].type === 'youtube',
			'vidonly': totalAmt <= 1 && mediadata[0].type === 'vid',
		}">
			<div class="sizer" v-if="sizer !== null" v-bind:style="'padding-bottom:' + sizer + '%'"></div>
			<div
				class="media-loop-single"
				v-for="(mediasingle, indexmedia) in mediadata"
				v-bind:loopinstance="indexmedia"
				v-bind:key="indexmedia"
				v-bind:class="{'media-active' : active === indexmedia}"
			>
				<transition name="crossfade">
				<div
					v-show="mediasingle.type === 'img' && active === indexmedia"
					class="media-single media-img"
					:class="mediasingle.orient"
				>
					<div class="single-sizer" v-bind:style="'padding-bottom:' + ((mediasingle.height/mediasingle.width)*100) + '%'"></div>
					<div class="img-il-wrap">
						<div class="img-il">
							<img
								:src="
									rootPath + mediasingle['src-thumb']
								"
								:srcset="rootPath + mediasingle['src-med'] + ' 1024w, '+ rootPath + mediasingle['src-large'] + ' 2048w'"
								v-on:click="progressImg()"
								v-bind:width="mediasingle.width"
								v-bind:height="mediasingle.height"
								oncontextmenu="return false"
								draggable="false"
								border="0"
							/>
							<span v-if="active === indexmedia && mediasingle.enlarge" class="magnify" v-on:click="$parent.$parent.$parent.$parent.imgModal = rootPath + mediasingle['src-large']"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/></svg></span>
						</div>
					</div>
				</div>
				</transition>
				<div
					v-if="mediasingle.type === 'youtube' && active === indexmedia"
					class="media-yt"
					v-html="'<div class=\'media-single media-vid\'>' + mediasingle.youtube+ '</div>'"
				></div>
				<div v-if="mediasingle.type === 'video' && active === indexmedia" class="media-vid">
					<div class='media-single media-vid'><video v-bind:source="mediasingle.video"></video></div>
				</div>
				
			</div>

			<div class="img-navs" v-if="totalAmt > 1">
				<span
					v-for="(mediasinglenav, indexmedianav) in mediadata"
					v-bind:class="{ active: active === indexmedianav }"
					v-on:click="active = indexmedianav"
					v-bind:key="indexmedianav"
				></span>
			</div>
		</div>
		<div class="rest-width img-caption-wrap"
			v-for="(mediasinglecaption, indexmediacaption) in mediadata"
			v-bind:key="indexmediacaption"
		>
			<div v-if="active === indexmediacaption && mediasinglecaption.caption.length > 5" class="img-caption minus" v-html="mediasinglecaption.caption"></div>
		</div>

	</div>
</template>

<script>
const SwipeListener = require('swipe-listener');
export default {
	created() {
		// flag switch point
		// this.rootPath =
		// 	process.env.NODE_ENV === "production"
		// 		? "http://54.87.134.1/wp-content/uploads"
		// 		: "http://54.87.134.1/wp-content/uploads";
		this.rootPath =
					process.env.NODE_ENV === "production"
						? "/interactives/moma_through_time/static/uploads/"
						: "/static/uploads/";
		this.totalAmt = this.mediadata.length;

		if(this.mediadata.length > 1){
			let keystone = 0;
			for(var i = 0; i < this.mediadata.length; i++){
				if(this.mediadata[i].type === 'img'){
					// let orient = this.mediadata[i].orient;
					let ar = this.mediadata[i].height/this.mediadata[i].width;
					if(ar > keystone){
						keystone = ar;
					}
				}
			}
			if(keystone > 0 && keystone < 0.9){
				this.sizer = keystone*100;
			}
		}
	},
	data() {
		return {
			hasImg: false,
			rootPath: "/",
			active: 0,
			totalAmt: 0,
			sizer:null,
			listener:null
		};
	},
	props: ["mediadata"],
	methods: {
		progressImg: function() {
			let temp = this.active + 1;
			if (temp >= this.totalAmt) {
				temp = 0;
			}
			this.active = temp;
		}
	},
	mounted() {
		// console.log(this.$el);
		let scopeThis = this;
		this.listener = SwipeListener(this.$el);
		this.$el.addEventListener('swipe', function (e) {
			if(e.detail.directions && e.detail.directions.left){
				let temp = scopeThis.active + 1;
				if (temp >= scopeThis.totalAmt) {
					temp = 0;
				}
				scopeThis.active = temp;
			} else if(e.detail.directions && e.detail.directions.right){
				let temp = scopeThis.active - 1;
				if (temp < 0) {
					temp = scopeThis.totalAmt - 1;
				}
				scopeThis.active = temp;
			}
		});
	}
};
</script>

<style lang="scss">
@import "../sass/_mq.scss";
.sizer {
	pointer-events:none;
	z-index:-5;
	@include tabletBelow {
		display:none;
	}
}
.media-single {
	height:100%;
	margin-left: auto;
	margin-right: auto;
	display:flex;
	flex-direction:column;
	overflow-y:hidden;
	overflow-x:visible;
	&.hor {
		@include aboveTablet {
			position:relative;
			height:auto;
			max-height:100%;
			overflow:visible;
			top:50%;
			transform:translateY(-50%);
			img {
				min-height:300px;
			}
			.no-nav & {
				top:0;
				transform:none;
			}
		}
	}
	// &.vert {
	// 	max-width: 75%;
	// }
	// &.vertX {
	// 	max-width: 55%;
	// }
	// &.vertX2 {
	// 	max-width: 45%;
	// }
	// &.vertX3 {
	// 	max-width: 35%;
	// }
	// &.vertX4 {
	// 	max-width: 25%;
	// }
	&.squareminus {
		max-width: 90%;
	}
	@include tabletBelow {
		&.media-vid {
			padding-bottom:75%;
		}
	}
	@include aboveTablet {
		.has-sizer & {
			position:absolute;
			top:0;
			left:0;
			right:0;
			bottom:0;
		}
	}
	iframe,video {
		position:absolute;
		top:0;
		left:50%;
		width:100%;
		height:100%;
		transform:translateX(-50%);
	}
}
.img-caption-wrap {
	&:last-child { min-height:14px; }
	.img-caption {
		width:100%;
		color:#888;
		p { 
			&:first-child { margin-top:0; }
			&:last-child { 
				margin-bottom:3.2em; 
				@include tabletBelow {
					margin-bottom:2em;
					font-size:13px;
				}
			}
		}
	}
}
.single-sizer {
	width:100%;
	pointer-events: none;
	z-index:-5;
	@include tabletBelow {
		display:none;
	}
}
.size-img {
	img {
		position: absolute;
		top: 0;
		left: 0;
		width: auto;
		height: 100%;
		display: block;
		margin-left: auto;
		margin-right: auto;
		cursor: pointer;
	}
}
.media-yt {
	width: 100%;
	margin-bottom: 30px;
	iframe {
		display: block;
		margin: auto;
	}
}
.media-vid {
	width: 100%;
	margin-bottom: 30px;
	video {
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
}
.of-media-wrap {
	position: relative;
	margin-left: 100px;
	margin-right: 100px;
	margin-bottom: 70px;
	@media (max-width: 700px) {
		margin-left: 0;
		margin-right: 0;
	}
	&.no-nav {
		margin-bottom: 40px;
	}
	&.no-nav.hor, &.no-nav.vidonly {
		height:auto;
	}
}
.media-loop-single {
	position:absolute;
	top:0;
	left:0;
	right:0;
	bottom:0;
	&.media-active {
		z-index:2;
	}
	.no-nav.hor &, .no-nav.vidonly & {
		position:relative;

	}
}

.of-media-wrap {
	backface-visiblity: hidden;
	height: 700px;
	text-align:center;
	@media (max-height: 800px) {
		height: 85vh;
	}
	.hor img {
		max-height: 700px;
		@media (max-height: 800px) {
			max-height: 85vh;
		}
	}
	@include tabletBelow {
		display:block;
		height:auto;
		.media-loop-single {
			position:relative;
			// .img-il {
			// 	height:auto;
			// 	width:100%;
			// 	max-height:100%;
			// 	img {
			// 		width:100%;
			// 		height:auto;
			// 	}
			// }
		}
	}

	img {
		// max-width: 100%;
		// height: auto;
		// margin-left: auto;
		// margin-right: auto;
		// object-fit: contain;
		height:100%;
		width:auto;
		@include tabletBelow {
			width:100%;
			height:100%;
			object-fit:contain;
			object-position:50% 50%;
		}
	}
}
@include aboveTablet {
	.img-il-wrap {
		position:absolute;
		top:0;
		left:0;
		width:100%;
		height:100%;
		display:flex;
		overflow:hidden;
		.hor & {
			overflow: visible;
		}
	}
}
.img-il {
	position:relative;
	display:inline-block;
	margin:auto;
	height:100%;
	max-width:100%;
	// overflow-y:hidden;
	.single-sizer {
		display:none;
	}
	@include aboveTablet {
		.hor & {
			height:auto;
			// width:100%;
			max-height:100%;
			display:flex;
			.il-img-wrap {
				display:inline-block;
				max-height:100%;
			}
			img {
				height:auto;
				max-width:100%;
				display: block;
			}
		}
	}
}

// Horizontal image rules
// .of-media-wrap {
// 	.hor img {
// 		width:100%;
// 		height:auto;
// 		@media (max-height: 800px) {
// 			width:auto;
// 			height:100%;
// 		}		
// 	}
// }
// .img-il {
// 	.hor & {
// 		height:auto;
// 		width:100%;	
// 		@media (max-height: 800px) {
// 			height:100%;
// 			width:auto;
// 		}
// 	}
// }

.of-media-wrap.has-sizer {
	position:relative;
	height:auto;
	.of-img {
		height:100%;
		img {
			max-height:100%;
		}
	}
	.media-single.hor {
		top:0;
		transform:none;
		img {
			max-height:none;
		}
	}
}

// .no-nav,
// .no-nav .of-img {
// 	height: auto;
// 	max-height: 700px;
// 	@media (max-height: 800px) {
// 		height: auto;
// 		max-height: 90vh;
// 	}
// }
.of-img {
	position: relative;
	display: flex;
	
	@include tabletBelow {
		display:block;
		height:auto;
	}
	// @media (max-height: 750px) {
	// 	display:block;		
	// 	img {
	// 		object-fit:initial;
	// 	}
	// }
}
.img-navs {
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	text-align: center;
	margin-top: 14px;
	display: block;
	.no-nav & {
		display: none;
	}
	span {
		position: relative;
		display: inline-block;
		width: 20px;
		height: 40px;
		cursor: pointer;
		&:before {
			content: "";
			position: absolute;
			top: 50%;
			left: 50%;
			width: 8px;
			height: 8px;
			transform: translateX(-50%) translateY(-50%);
			background: #666666;
			border-radius: 50%;
		}
		&.active:before {
			background: white;
		}
	}
}
.magnify {
	position:absolute;
	bottom:-9px;
	right:-40px;
	width:40px;
	height:40px;
	cursor:pointer;
	@include tabletBelow {
		right:4px;
		bottom:9px;
		background:rgba(0,0,0,0.3);
		border-radius:2px;
	}
	svg {
		position:absolute;
		top:50%;
		left:50%;
		transform:translateX(-50%) translateY(-50%);
		width:24px;
		height:24px;
		pointer-events:none;
		path { fill:white; }
	}
	&:ACTIVE {
		opacity:0.5;
	}
}

.fade-enter-active, .fade-leave-active {
	// transition: opacity 3s;
}
.fade-enter {
	opacity:0;
}
.fade-leave-to {
	transition-duration:1s;
	opacity: 0;
	position:absolute;
	top:0;
	left:0;
	right:0;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.crossfade-enter-active {
  transition: all .3s ease;
}
.crossfade-leave-active {
	position:absolute;
  transition: all .15s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.crossfade-enter, .crossfade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  // transform: translateX(10px);
  opacity: 0;
}
</style>
